import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HCPService } from '../hcp.service';
import { HttpEventType } from '@angular/common/http';
import { AttachmentFile } from '../../../expenses/models/attachement-file.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
 import { AttachementFileApiService } from '../../../services/attachement-file-api.service';
import { Permission } from '../../../models/permission.model';
import { AccountService } from '../../../services/account.service';
import { AppTranslationService } from '../../../services/app-translation.service';
  
@Component({
  selector: 'crm-hcp-attachements',
  templateUrl: './hcp-attachements.component.html',
  styleUrls: ['./hcp-attachements.component.css']
})
export class HcpAttachementsComponent implements OnInit {

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() hcpId: number;
  files: AttachmentFile[] = [];
  progress;
  hcp: any;
  constructor(private alertService: AlertService, private attachmentFileApiService: AttachementFileApiService, private hcpService: HCPService,
    private accountService: AccountService,
    private translateService: AppTranslationService) { }

  ngOnInit() {
    this.getAttachements();
  }

  getAttachements() {
    this.hcpService.getHcpAttachements(this.hcpId).subscribe(response => {
      this.hcp = response as any;
      this.files = this.hcp.files;
    });
  }

  saveAttachements() {
    this.hcp.files = this.files;
    this.hcpService.saveHcpAttachements(this.hcp).subscribe(response => {
      this.alertService.showMessage("", this.translateService.getTranslation("Saved Successfully"), MessageSeverity.Success);
      this.closeEvent.emit(false);

    });
  }

  onFileSelect(event) {
    console.log(event);
    if (event.addedFiles.length === 0 || !this.manageAttachementsHcps)
      return;

    const formData = new FormData();

    for (let file of event.addedFiles)
      formData.append(file.name, file);

    this.attachmentFileApiService.upload(formData, "hcp").subscribe(resp => {
      if (resp.type === HttpEventType.UploadProgress)
        this.progress = Math.round(100 * resp.loaded / resp.total);
      else if (resp.type === HttpEventType.Response) {
        let file: AttachmentFile = resp.body as AttachmentFile;

        this.files.push(file);
      }
    });
  }

  onFileRemove(file) {
    this.attachmentFileApiService.delete(file.id).subscribe(response => {
      let res = response as any;
      if (res.successful) {
        let index = this.files.indexOf(file);
        this.files.splice(index, 1);
      }
    }, error => {
      console.log(error);
    });
  }

  openFile(url: string) {
    if (url != "" && url != undefined) {
      window.open(url, "_blank");
    }
  }

  back() {
    this.closeEvent.emit(false);
  }

  get manageAttachementsHcps() {
    return this.accountService.userHasPermission(Permission.manageAttachementsHcpsPermission);
  }


}
